import { Component, ErrorInfo, ReactNode } from 'react';

import { Error as ErrorPage } from '@/shared/pages/Error/Error';
import { getRum } from '@/shared/rum/apm';

type Props = { children: ReactNode };
type State = { hasError: boolean };

export class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false };

  componentDidCatch(error: Error, info: ErrorInfo) {
    // In production React suppresses re-throwing errors caught by an error boundary,
    // so APM's global window.onerror handler never fires. We must report manually.
    getRum()?.captureError(error, {
      labels: { componentStack: info.componentStack ?? '' },
    });

    if (/Loading chunk [\d]+ failed/.test(error.message)) {
      window.location.reload();
    }
  }

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  render() {
    if (this.state.hasError) {
      return (
        <ErrorPage
          title="Something went wrong"
          description={
            <p>An unexpected error occurred. Try refreshing the page.</p>
          }
          onRefresh={() => window.location.reload()}
        />
      );
    }

    return this.props.children;
  }
}
